module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Qdz9eo/tc-custom/9781398452169.jpg?1705056296516",
      "alt": "This image is the cover for the book The Road to Westminster"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Road to Westminster\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Nothing in life is impossible provided you never lose sight of your goal and are willing to be flexible at all times and totally dedicated to achieving your aims. Setbacks crop up at the most inconvenient times, but they give you the opportunity to make changes, accept new challenges and achieve your targets in ways you could never have thought possible. "), _c('br'), _vm._v("Never give up, never lose sight of your objectives. Be ruthless when assessing your progress. Take chances when you need to. Everyone needs to speculate to accumulate. Go for it at all times.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Den Dover\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Den Dover never knew his father until the end of the wars in Europe and Burma. He lived halfway between Liverpool and Manchester under the bombers’ airpaths. American soldiers and airmen were the heroes of his childhood years. Churchill was his hero and the saviour of Britain. Den resolved that he would follow Churchill by dedicating his life to caring and providing for the people by becoming a Member of Parliament.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0